import { useContext, useState } from "react";
import { useConstants } from "../../hooks/UseConstants";
import AuthContext from "../../context/AuthContext";
import { useWaits } from "../../hooks/UseWait";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { useWallet } from "../../hooks/UseWallet";
import Fetch from "../../services/Fetch";
import { buildWalletFormData } from "../../helper/WalletFormData";
import { usePopups } from "../../hooks/UsePopups";
import QrCodeWallet from "../../popup/QrCodeWallet";
import { FormattedMessage } from "react-intl";
import AdminPageHero from "../../components/AdminPageHero";
import DashboardPanelCard from "../../components/cards/DashboardPanelCard";
import PageContent from "../../components/PageContent";
import ScrollReveal from "../../components/motion/ScrollReveal";
import ModalOverlay from "../../components/ModalOverlay";

function Wallet() {
    const { wait } = useContext(AuthContext);
    const { setPopup } = usePopups();
    const { host, language } = useConstants();
    const { sendWait, setSendWait } = useWaits();
    const { amount, setAmount } = useWallet();
    const [qrCode, setQrCode] = useState('');

    const addToWallet = async () => {
        setSendWait(true);
        const formData = buildWalletFormData({ amount: amount });
        let result = await Fetch(host + `/admin/wallet/charge/create`, 'POST', formData);

        if (result.status === 200) {
            setQrCode(result.data.data);
            setPopup('qrcode', 'flex');
        }
        setSendWait(false);
    }

    return (
        <>
            <PageContent wait={wait} loading={false}>
                <AdminPageHero subtitle={<FormattedMessage id="fill_wallet" />} />
                <ScrollReveal>
                    <Box sx={{ maxWidth: 440, mx: 'auto' }}>
                        <DashboardPanelCard
                            title={<FormattedMessage id="fill_wallet" />}
                            className="mx-0 text-center"
                        >
                            <TextField
                                label={<FormattedMessage id="amount" />}
                                className="w-full !my-6"
                                variant="outlined"
                                type="number"
                                onChange={(e) => setAmount(e.target.value)}
                            />
                            <Button
                                onClick={addToWallet}
                                fullWidth
                                variant="contained"
                                size="large"
                                disabled={sendWait}
                                sx={{
                                    py: 1.35,
                                    fontWeight: 700,
                                    borderRadius: 2,
                                    background: 'linear-gradient(135deg, #0D358C 0%, #2563EB 100%)',
                                }}
                            >
                                {sendWait ? (
                                    <CircularProgress size={20} color="inherit" />
                                ) : (
                                    <FormattedMessage id="create" />
                                )}
                            </Button>
                        </DashboardPanelCard>
                    </Box>
                </ScrollReveal>
            </PageContent>

            <ModalOverlay id="qrcode" onClose={() => setPopup('qrcode', 'none')}>
                <QrCodeWallet payload={qrCode} onClickClose={() => setPopup('qrcode', 'none')} />
            </ModalOverlay>
        </>
    );
}


export default Wallet;